import React, { useEffect, useRef, useState } from "react";
import "./TopBar.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UilUser, UilSignOutAlt } from "@iconscout/react-unicons";
import { emptyUser } from "../../Redux/slices/AuthSlice";

const PAGE_TITLES = {
  "/":            "Dashboard",
  "/orders":      "Commandes",
  "/products":    "Produits",
  "/designs":     "Modèles",
  "/add-product": "Nouveau Produit",
  "/add-design":  "Nouveau Modèle",
  "/add-category":"Nouvelle Catégorie",
  "/add-theme":   "Nouveau Thème",
  "/add-user":    "Nouvel Employé",
  "/add-client":  "Nouveau Client B2B",
  "/clients":     "Clients B2B",
  "/analytics":   "Statistiques",
  "/roles":       "Rôles & Permissions",
  "/sessions":    "Sessions",
  "/audit-log":   "Journal d'audit",
  "/profile":     "Mon Profil",
};

const getTitle = (pathname) => {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  if (pathname.startsWith("/clients/")) return "Fiche Client";
  if (pathname.startsWith("/products/")) return "Modifier Produit";
  if (pathname.startsWith("/designs/edit/")) return "Modifier Modèle";
  return "";
};

const TopBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.currentUser);

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const title = getTitle(location.pathname);
  const worker = currentUser?.worker;
  const initials = worker
    ? `${(worker.name || "")[0] || ""}${(worker.surname || "")[0] || ""}`.toUpperCase()
    : "?";
  const fullName = worker ? `${worker.name || ""} ${worker.surname || ""}`.trim() : "";

  const clearStoredAuth = () => {
    ["persist:root", "token", "refreshToken", "user", "worker", "admin"].forEach(
      (k) => localStorage.removeItem(k)
    );
  };

  const handleLogOut = () => {
    clearStoredAuth();
    dispatch(emptyUser());
    navigate("/login");
  };

  return (
    <header className="topbar">
      <h1 className="topbar-title">{title}</h1>

      <div className="topbar-right">
        <div className="topbar-user-menu" ref={menuRef}>
          <button
            type="button"
            className="topbar-user"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            {worker?.img ? (
              <img src={worker.img} alt="" className="topbar-avatar topbar-avatar-img" />
            ) : (
              <div className="topbar-avatar">{initials}</div>
            )}
            <div className="topbar-user-info">
              <span className="topbar-user-name">{fullName}</span>
              <span className="topbar-user-role">
                {worker?.roleId?.name || (worker?.isAdmin ? "Administrateur" : "Employé")}
              </span>
            </div>
          </button>

          {menuOpen && (
            <div className="topbar-dropdown">
              <Link to="/profile" className="topbar-dropdown-item" onClick={() => setMenuOpen(false)}>
                <UilUser size={16} />
                Mon Profil
              </Link>
              <div
                className="topbar-dropdown-item danger"
                onClick={() => {
                  setMenuOpen(false);
                  handleLogOut();
                }}
              >
                <UilSignOutAlt size={16} />
                Déconnexion
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopBar;
